import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: "#ee44aa",
                secondary: "#424242",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FFC107",
                main: "#FFBD2E",
                lgreen: "#29CC41",
                lhgreen: "#99FF99",
                lred: "#FF6059",
                lhred: "#D60509",
                lBlue: ""
            }
        }
    },
    icons: {
        iconfont: "mdi"
    }
});